export default __webpack_public_path__ + "static/all-601ad385f2d6d062b385ec57275fa559.jpg";